import React from "react";

export const TRANSACTION_TYPE_PURCHASE = 1;
export const TRANSACTION_TYPE_SALE = 2;

export const DEFAULT_POSTS_PER_PAGE = 14;

export const PresentationFields = {
    MY_COMIC_SHOP: 'mcs',
    EBAY: 'ebay',
    THIRD_EYE: 'third_eye',
    ISSUE: 'issue',
    TITLE: 'title',
    TAGS: 'tags',
    CATEGORY: 'category',
    DESCRIPTION: 'description',
    LINK: 'link',
    DATE: 'date',
}

export const ShowElements = {
    HERO_HEADER: 'heroHeader',
    RELATED_POSTS: 'relatedPosts',
    AUTHORS: 'authors',
    PAGINATION: 'pagination',
    PAGINATION_TOP: 'paginationTop',
    PAGINATION_BOTTOM: 'paginationBottom',
    SHARE_BUTTONS: 'shareButton',
    DATE: 'date',
}

export const CtaTypes = {
    YOUTUBE: 'Youtube',
    COVER: 'Cover',
    ISSUE_COVERART: 'IssueCoverArt',
}

export const DataShape = {
    TABLE: 'table',
    DEFAULT: 'default',
}

export const StatusCodes = {
    ERROR: 'error',
    NO_POSTS_FOUND: 'no_posts_found',
    NO_PAGES_FOUND: 'no_pages_found',
    NO_ISSUES_FOUND: 'no_issues_found',
    COOKIE_INVALID_NONCE: 'rest_cookie_invalid_nonce',
}

export const ReturnType = {
    LABEL_VALUE: 'label_value',
}

export const QueryParmsViewTypes = {
    ISSUES: 'issues',
    SERIES: 'series',
    BOXES: 'boxes',
    WISHLIST: 'wishlist',
}

export const IssueGradeTypes = {
    GRADED: 'GRADED',
    SLAB: 'SLAB',
}

export const Routes = {
    ROOT: '/',
    PARTNER_PORTAL: '/partner-portal/',
    PARTNER_PORTAL_PROFILE: '/partner-portal/profile/',
    TOKEN: 'token',
    ISSUE: '/issue',
    NEW_RELEASES: '/new-releases',
    MY_COLLECTION: '/my-collection',
    SEARCH: '/search',
    WEEKLY_TOP_TEN: '/weekly-top-ten',
    DAILY_HOT: '/daily-hot',
    DAILY_SHAKERS: '/daily-shakers',
    WEEKLY_MOVERS: '/weekly-movers',
    KEY_ISSUES: '/key-issues',
    RARE_ISSUES: '/rare-issues',
    TOP_VARIANTS: '/top-variants',
    BOX_ISSUES: '/box-issues',
    SERIES_ISSUES: '/series-issues',
    SERIES: '/series',
    COLLECTOR_CONTENT: '/cp-content',
    COLLECTOR_CONTENT_SEARCH: '/cp-content/search',
    MARKETPLACE: '/marketplace',
    DYNAMIC_PAGE: '{{DYNAMIC_PLACEHOLDER}}',
    MEMBERSHIP_PLANS_PAGE: '/plans/unlimited',
    SIGN_UP: '/register',
    RESTRICTED_ACCESS: '/restricted-access',
    PLAN_PREMIUM: '/plans/unlimited',
    DESCRIPTOR_LIST: '/descriptor-list',
    ISSUES: '/issues',
}

export const CmsBreakPointsDefaults = {
    DESKTOP: {
        TOTAL: 6,
        GUTTER: 30
    },
    TABLET: {
        TOTAL: 4,
        GUTTER: 30
    },
    MOBILE: {
        TOTAL: 2,
        GUTTER: 30
    },
}

export const AffiliateLinksCopy = {
    MCS: 'Shop MCS',
    EBAY: 'Shop eBay',
    THIRD_EYE: 'Shop Third Eye',
} 

export const QueryParms = {
    PAGE: 'curPage',
    PER_PAGE: 'perPage',
    FILTERS: 'filters',
    DRAWER_OPEN: 'drawerOpen',
    ISSUE_ID: 'issue_id',
    DATES: 'dates',
    DATE: 'date',
    TERMS: 'terms',
    SEARCH: 'search',
    ORDER_TITLE: 'orderTitle',
    ORDER_DATE: 'orderDate',
    ORDER_EXCERPT: 'orderExcerpt',
    ORDER_CATEGORY: 'orderCategory',
}

export const ModalCopy = {
    totalFMV: {
        title: 'Total FMV',
        content: `
            <p>The Total FMV column allows you to know what each of the Virtual Boxes in your&nbsp;
                <b>COVR</b>PRICE collection are worth, based on the individual FMVs for each comic
                you've added to that Virtual Box.
            </p>
            <p>
                You can either update each Virtual Box individually (by selecting the refresh
                button next to each Virtual Box FMV)  or all at once (by selecting the refresh
                icon in the column header).
            </p>
        `
    }
}

export const IssueActions = {
    WISHLIST: {
        ADD: 'Add to Wishlists',
        REMOVE: 'Remove from Wishlists',
        RESPONSE: {
            ADD: 'Issue added to wishlist.',
            REMOVE: 'Issue removed from wishlist',
        },
        ERROR: {
            ADD: 'Failed to add issue to wishlist.',
            REMOVE: 'Failed to remove issue from wishlist.',
        },
    },
    COLLECTION: {
        ADD: 'Add to Collection',
        REMOVE: 'Remove from Collection',
    },
    MARKETPLACE: {
        BUY: 'Buy in Marketplace',
    },
}

export const SubscriptionTypes = {
    BASIC: 'basic',
    TRIAL: 'trial',
    STANDARD: 'standard',
    UNLIMITED_MONTHLY: 'unlimited-monthly',
    UNLIMITED_YEARLY: 'unlimited-yearly',
}

export const ImageUknown = {
    COVER: 'https://covrprice.com/wp-content/themes/covr/assets/images/default_cover.jpg',
    BROKEN: '',
}

export const SalesListTypes = {
    DAILY_HOT: {
        listType: 'DAILY_HOT',
        pageSlug: 'daily-hot',
        helpTitle: "Daily Hot List",
        helpContent: (<>
            <p>The Daily Hot List helps you find comics that are trending right now.</p>
            <p>COVRPRICE rank orders all the comics in our system by the total volume of daily sales, significant jumps in Fair Market Value (FMV), and some secret sauce so that today's HOT comics rise to the top.</p>
            <p>Use this daily generated list for a snapshot of comics to keep an eye on.</p>
        </>),
    },
    DAILY_SHAKERS: {
        listType: 'DAILY_SHAKERS',
        pageSlug: 'daily-shakers',
        helpTitle: "Daily Hot List",
        helpContent: (<>
            <p>The Daily Hot List helps you find comics that are trending right now.</p>
            <p>COVRPRICE rank orders all the comics in our system by the total volume of daily sales, significant jumps in Fair Market Value (FMV), and some secret sauce so that today's HOT comics rise to the top.</p>
            <p>Use this daily generated list for a snapshot of comics to keep an eye on.</p>
        </>),
    },
    WEEKLY_MOVERS: {
        listType: 'WEEKLY_MOVERS',
        pageSlug: 'weekly-movers',
        helpTitle: "Weekly Movers List",
        helpContent: (<>
            <p>The Weekly Movers List shows you comics with the highest number of items sold (i.e. Units Sold) in the last seven days across multiple online marketplaces.</p>
            <p>Use this list to see what comics the aftermarket is buying up each week.</p>
        </>),
    },
    WEEKLY_TOP_TEN: {
        listType: 'WEEKLY_TOP_TEN',
        pageSlug: 'weekly-top-ten',
        helpTitle: "Weekly Top Ten",
        helpContent: (<>TBC</>),
    },
}

export const IssueListTypes = {
    KEY_ISSUES: {
        pageSlug: 'key-issues',
        filters: {
            publishers: undefined,
            multipleDateRanges: undefined,
            isKey: true,
            sort: 2,
        },
        helpTitle: "Key Issues List",
        helpContent: (<><p>TBC</p></>),
    },
    RARE_ISSUES: {
        pageSlug: 'rare-issues',
        filters: {
            publishers: undefined,
            multipleDateRanges: undefined,
            isRare: true,
            sort: 2
        },
        helpTitle: "Rare Issues List",
        helpContent: (<><p>TBC</p></>),
    },
    TOP_VARIANTS: {
        pageSlug: 'top-variants',
        filters: {
            publishers: undefined,
            multipleDateRanges: undefined,
            isTopVariant: true,
            sort: 2,
        },
        helpTitle: "Top Variants",
        helpContent: (<><p>TBC</p></>),
    },
}

export const Grades = {
    slabbed: [
        {short_desc: '10', long_desc: 'Gem Mint [GM]', high: 10, low: 10 },
        {short_desc: '9.9', long_desc: 'Mint [M]', high: 9.9, low: 9.9 },
        {short_desc: '9.8', long_desc: 'Near Mint/Mint  [NM/M]', high: 9.8, low: 9.8 },
        {short_desc: '9.6', long_desc: 'Near Mint+ [NM+]', high: 9.6, low: 9.6 },
        {short_desc: '9.4', long_desc: 'Near Mint [NM]', high: 9.4, low: 9.4 },
        {short_desc: '9.2', long_desc: 'Near Mint- [NM-]', high: 9.2, low: 9.2 },
        {short_desc: '9.0', long_desc: 'Very Fine/Near Mint [VF/NM]', high: 9.0, low: 9.0 },
        {short_desc: '8.5', long_desc: 'Very Fine+ [VF+]', high: 8.5, low: 8.5 },
        {short_desc: '8.0', long_desc: 'Very Fine [VF]', high: 8.0, low: 8.0 },
        {short_desc: '7.5', long_desc: 'Very Fine- [VF-]', high: 7.5, low: 7.5 },
        {short_desc: '7.0', long_desc: 'Fine/Very Fine [F/VF]', high: 7.0, low: 7.0 },
        {short_desc: '6.5', long_desc: 'Fine+ [F+]', high: 6.5, low: 6.5 },
        {short_desc: '6.0', long_desc: 'Fine [F]', high: 6.0, low: 6.0 },
        {short_desc: '5.5', long_desc: 'Fine- [F-]', high: 5.5, low: 5.5 },
        {short_desc: '5.0', long_desc: 'Very Good/Fine [VG/F]', high: 5.0, low: 5.0 },
        {short_desc: '4.5', long_desc: 'Very Good+ [VG+]', high: 4.5, low: 4.5 },
        {short_desc: '4.0', long_desc: 'Very Good [VG]', high: 4.0, low: 4.0 },
        {short_desc: '3.5', long_desc: 'Very Good- [VG-]', high: 3.5, low: 3.5 },
        {short_desc: '3.0', long_desc: 'Good/Very Good [GD/VG]', high: 3.0, low: 3.0 },
        {short_desc: '2.5', long_desc: 'Good+ [GD+]', high: 2.5, low: 2.5 },
        {short_desc: '2.0', long_desc: 'Good [GD]', high: 2.0, low: 2.0 },
        {short_desc: '1.8', long_desc: 'Good- [GD-]', high: 1.8, low: 1.8 },
        {short_desc: '1.5', long_desc: 'Fair/Good [FR/GD]', high: 1.5, low: 1.5 },
        {short_desc: '1.0', long_desc: 'Fair [FR]', high: 1.0, low: 1.0 },
        {short_desc: '0.5', long_desc: 'Poor [PR]', high: 0.5, low: 0.5 },
        {short_desc: '0.3', long_desc: 'Coverless', high: 0.3, low: 0.3 },
    ],
    raw: [
        {short_desc: 'NM+', long_desc: 'NEAR MINT+', high: 10, low: 9.6 },
        {short_desc: 'NM', long_desc: 'NEAR MINT', high: 9.4, low: 9.0 },
        {short_desc: 'VF', long_desc: 'VERY FINE', high: 8.5, low: 7.0 },
        {short_desc: 'FN', long_desc: 'FINE', high: 6.5, low: 5.0 },
        {short_desc: 'VG', long_desc: 'VERY GOOD', high: 4.5, low: 3.0 },
        {short_desc: 'GD', long_desc: 'GOOD', high: 2.5, low: 1.5 },
        {short_desc: 'FR/PR', long_desc: 'FAIR/POOR', high: 1.0, low: 0.3 },
        {short_desc: 'NG', long_desc: 'NO GRADE', high: 0, low: 0 },
    ]
};
